"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const OverlayTooltip_1 = tslib_1.__importDefault(require("core/components/OverlayTooltip"));
const UnderlineErrorTest = (props) => {
    const style = {
        display: `${props.errorMessage ? 'inline' : 'none'}`,
        position: 'absolute',
        right: 5,
        width: 22,
        bottom: 7,
        ...props.style
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: 'error invalid-feedback text-right', style: style, children: props.errorMessage
            ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(OverlayTooltip_1.default, { direction: props.tooltipErrorDirection, content: props.errorMessage || null, errorMessage: true, children: (0, jsx_runtime_1.jsx)("i", { className: 'fa fa-exclamation-circle pointer text-danger p-1' }) }) })
            : null }));
};
exports.default = UnderlineErrorTest;
